import axios from 'axios'

export default {
  getFirstSubmitList(params) {
    return axios.post('/api/rendering/admin/front/user/queryFirstSubmitList', params)
  },
  exportFirstSubmitList(params) {
    return axios.post('/api/rendering/admin/statistics/user/exportFirstSubmitList', params)
  },
}
